import { render, staticRenderFns } from "./Duty.vue?vue&type=template&id=da19cc58&scoped=true&"
import script from "./Duty.vue?vue&type=script&lang=ts&"
export * from "./Duty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da19cc58",
  null
  
)

export default component.exports